module.exports = "/images/fa.svg";